import React from 'react';
import './InfoText.css';

function InfoText() {
    return (
        <div className="info-container">
            <p>
                I studied computer science in Germany and I'm currently working as a full time Software Engineer.
                I love building new and exciting things with various different technologies and languages.
            </p>
        </div>
    );
}

export default InfoText;